const overrideCardStyles = theme => ({
	MuiCard: {
		styleOverrides: {
			root: {
				backgroundColor: theme.palette.background.grey,
			}
		}
	}
})

export default overrideCardStyles